"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/inherits.js"));
var _react = _interopRequireDefault(require("react"));
var _PointerHandler = _interopRequireDefault(require("../PointerHandler"));
var _Cropper = _interopRequireDefault(require("./Cropper"));
var _urlToImage = _interopRequireDefault(require("./urlToImage"));
var _blobToDataUrl = _interopRequireDefault(require("./blobToDataUrl"));
var _drawImage = _interopRequireDefault(require("./drawImage"));
var _drawClip = _interopRequireDefault(require("./drawClip"));
var _getDistance = _interopRequireDefault(require("./getDistance"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/ImageCropper/index.js";
var defaultProps = {
  width: 500,
  height: 500,
  border: 50,
  borderRadius: 50,
  scale: 1,
  rotate: 0
};
var ImageCropperControl = /*#__PURE__*/function (_React$Component) {
  function ImageCropperControl(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ImageCropperControl);
    _this = (0, _callSuper2["default"])(this, ImageCropperControl, [props]);
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    var border = props.border * 2;
    _this.cropper = new _Cropper["default"](props.width + border, props.height + border);
    return _this;
  }
  (0, _inherits2["default"])(ImageCropperControl, _React$Component);
  return (0, _createClass2["default"])(ImageCropperControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.src) {
        this.loadImage(this.props.src);
      }
      var canvas = this.ref.current;
      this.pointer = new _PointerHandler["default"](canvas, this.handleEvent.bind(this));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var oldScale = prevProps.scale;
      var newScale = this.props.scale;
      if (oldScale !== newScale) {
        this.cropper.photo.setScale(newScale);
        this.draw();
      }
    }
  }, {
    key: "loadImage",
    value: function loadImage(src) {
      var _this2 = this;
      if (typeof src === "string") {
        (0, _urlToImage["default"])(src, "anonymous").then(function (image) {
          _this2.handleImageReady(image);
        });
      } else if (src instanceof File) {
        (0, _blobToDataUrl["default"])(src).then(function (url) {
          _this2.loadImage(url);
        });
      }
    }
  }, {
    key: "handleImageReady",
    value: function handleImageReady(image) {
      this.image = image;
      this.cropper.setCLip(this.props.width, this.props.height);
      this.cropper.setPhoto(this.image.width, this.image.height, this.props.scale);
      this.draw();
    }
  }, {
    key: "handleEvent",
    value: function handleEvent() {
      var events = this.pointer.getEvents();
      if (events.length === 1) {
        var event = events[0];
        switch (event.type) {
          case 'pointerdown':
            this.lastDistance = null;
            this.lastX = event.x;
            this.lastY = event.y;
            break;
          case 'pointermove':
            if (this.lastDistance) return;
            var deltaX = event.x - this.lastX;
            var deltaY = event.y - this.lastY;
            this.lastX = event.x;
            this.lastY = event.y;
            // get how many percent change from the size of canvas
            var normalX = deltaX / this.cropper.width;
            var normalY = deltaY / this.cropper.height;
            // convert the percent to the actual width of photo
            var addedX = this.cropper.photo.getWidth() * normalX;
            var addedY = this.cropper.photo.getHeight() * normalY;
            // add the changes to the current position of photo
            var x = this.cropper.photo.x + addedX;
            var y = this.cropper.photo.y + addedY;
            this.cropper.movePhoto(x, y);
            this.draw();
            break;
          default:
        }
      } else if (events.length === 2) {
        var zoom = this.getZoom(events);
        if (zoom) {
          var currentScale = this.cropper.photo.scale + zoom / 100;
          this.cropper.scalePhoto(currentScale);
          this.draw();
        }
      }
    }
  }, {
    key: "getZoom",
    value: function getZoom(events) {
      var zoom = false;
      var currentDistance = (0, _getDistance["default"])(events[0].x, events[0].y, events[1].x, events[1].y);
      if (this.lastDistance) {
        var distance = currentDistance - this.lastDistance;
        zoom = distance;
      }
      this.lastDistance = currentDistance;
      return zoom;
    }
  }, {
    key: "draw",
    value: function draw() {
      requestAnimationFrame(this.drawFrame.bind(this));
    }
  }, {
    key: "drawFrame",
    value: function drawFrame() {
      var canvas = this.ref.current;
      var width = canvas.width;
      var height = canvas.height;
      var c = canvas.getContext('2d');
      // clear canvas
      c.clearRect(0, 0, width, height);
      // start drawing
      (0, _drawImage["default"])(c, this.image, this.cropper);
      (0, _drawClip["default"])(c, this.cropper, this.props.borderRadius);
      this.getCrop();
    }
  }, {
    key: "getCrop",
    value: function getCrop(fileType) {
      var canvas = document.createElement('canvas');
      canvas.width = this.cropper.clip.width;
      canvas.height = this.cropper.clip.height;
      var ctx = canvas.getContext('2d');
      if (fileType === 'image/jpeg') {
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }
      if (this.image) {
        var x = this.cropper.photo.x - this.props.border;
        var y = this.cropper.photo.y - this.props.border;
        var width = this.cropper.photo.getWidth();
        var height = this.cropper.photo.getHeight();
        ctx.drawImage(this.image, x, y, width, height);
      }
      return canvas;
    }
  }, {
    key: "render",
    value: function render() {
      var defaultStyle = {
        cursor: "move",
        touchAction: 'none',
        userSelect: 'none'
      };
      var attributes = {
        className: this.props.className,
        width: this.cropper.width,
        height: this.cropper.height,
        style: (0, _objectSpread2["default"])({}, defaultStyle)
      };
      return /*#__PURE__*/_react["default"].createElement("canvas", Object.assign({
        ref: this.ref
      }, attributes, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 168,
          columnNumber: 13
        }
      }));
    }
  }]);
}(_react["default"].Component);
ImageCropperControl.defaultProps = defaultProps;
var _default = exports["default"] = ImageCropperControl;